export default {
  banner: {
    title1: "Authing 已支持",
    title2: "用户安全登录",
    subtitle: "连接全球人与应用，致力于通过生产力科技提供人们创新的平台",
    intro: {
      title: "以开发者为中心的全场景身份云产品",
      descript:
        "Authing 是一款以开发者为中心的全场景身份云产品，集成了所有主流身份认证协议，为企业和开发者提供完善安全的用户认证和访问管理服务。",
      descript1:
        "Authing 被科技部认定为「2020 国家高新技术企业」，被中国信息通信研究院评选为「国内身份管理与访问控制领域创新企业」，并被录入《2019 网络安全产业白皮书》。",
      descript2:
        "2021 年 8 月，Authing 入选福布斯亚洲的「最值得关注公司」百强榜单。2021 年 9 月，Authing 顺利入选中国信息通信研究院「卓信大数据计划」的第三批成员单位。",
      descript3:
        "如今，Authing 已经在全球拥有 200 多名员工，并已为中国石油、国家电网、元气森林、招商银行、日本丰田、德高集团等国内外优秀企业打造了卓越的开发方式、高效的办公流程和安全的 IT 管理体系。",
    },
  },
  process: {
    item1: {
      date: "2019.06",
      text: "公司成立，并获得硅谷著名孵化器「PLUG and PLAY」种子轮投资",
      textEn:
        "Authing was founded and received a seed round investment from the famous Silicon Valley incubator PLUG and PLAY.",
    },
    item2: {
      date: "2019.12",
      text: "被收录至「2019 年网络安全产业报告」安全产品全景图",
      textEn: `Included in the "2019 Cybersecurity Industry Report" security product panorama.`,
    },
    item3: {
      date: "2020.02",
      text: "获得「华创资本」和陆奇博士领导的「奇绩创坛」近千万元天使轮投资",
      textEn: `Received an angel round investment of nearly 10 million RMB from China Growth Capital and Miracleplus (YC China).`,
    },
    item4: {
      date: "2021.01",
      text: "获得「GGV 纪源资本」500 万美元 Pre-A 轮投资",
      textEn: `Received $5 million in Pre-A round of investment from GGV Capital.`,
    },
    item5: {
      date: "2021.08",
      text: "入选福布斯亚洲「最值得关注公司」百强榜单",
      textEn: `2021 "Forbes Asia 100 To Watch".`,
    },
    item6: {
      date: "2021.10",
      text:
        "获得由「老虎环球基金」领投，「鼎晖 VGC」、「声网 Agora」、「GGV 纪源资本」和「奇绩创坛」跟投，共计 2300 万美元 A 轮投资",
      textEn: `Series A investment led by Tiger Global Fund and followed by CDH VGC, Agora, GGV Capital and Miracleplus for a total of $23 million.`,
    },
    item7: {
      date: "Future",
      text: "连接全球人与应用",
      textEn: `Connect every person and app on the planet.`,
    },
  },
  future: {
    title: "我们的未来",
    item1: {
      title: "Authing 的使命",
      subtitle: `“让身份像水电一样即需即用”`,
      subtitleEn: `Let identity be like water and electricity`,
    },
    item2: {
      title: "Authing 的愿景",
      subtitle: `“连接全球人与应用”`,
      subtitleEn: `Connect every person and app on the planet`,
    },
    item3: {
      title: "Authing 的产品",
      subtitle: `“以开发者为中心”`,
      subtitleEn: `Developer-centric`,
    },
    item4: {
      title: "Authing 的服务",
      subtitle: `“客户的成功，就是 Authing 的成功”`,
      subtitleEn: `The success of our customers is the success of Authing`,
    },
  },
  join: {
    title: "加入 Authing，与我们共驭身份挑战",
    total: "总部",
    nation: "全国",
    citys: "5 个城市",
    found: "Authing 成立",
    partner: "Authinger 伙伴",
    connect: "连接应用",
    server: "用户服务数",
    beijing: "北京",
    shanghai: "上海",
    shenzhen: "深圳",
    chendu: "成都",
    wuhan: "武汉",
    address: "北京市朝阳区北辰世纪中心 B 座 16 层",
    button: "加入我们",
  },
  cutomer: {
    title: "从初创公司到行业第一",
    subtitle: "Authing 已帮助 1200+ 公司和数万开发者构建标准化的用户身份体系",
  },
};
